module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canDisplay_A('safetyplanmanagement') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Safety Plan Management"
    }
  })], 1) : _c('div', {
    staticClass: "compliance_doc"
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_c('i', {
    staticClass: "fa fa-book fa-1x",
    staticStyle: {
      "color": "white !important"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v("\n                    Safety Plan Management  " + _vm._s(_vm.locationName) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "25px!important"
    }
  }, _vm._l((_vm.arrayOfElementsFromServer), function(oneElement) {
    return _c('div', {
      key: oneElement.idx
    }, [(_vm.$hydrowareSecurityJS.canUpload_A('safetyplanmanagement')) ? _c('div', {
      staticClass: "upload-btn-wrapper"
    }, [_c('div', [_c('button', {
      staticClass: "btn-wrap",
      staticStyle: {
        "padding": "0px 2px 0px 2px",
        "font-size": "20px"
      },
      attrs: {
        "size": "small",
        "title": "Upload"
      }
    }, [_c('i', {
      staticClass: "fa fa-upload"
    })]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "name": 'speUploadBtn_' + oneElement.idx,
        "id": 'speUploadBtn_' + oneElement.idx
      },
      on: {
        "change": _vm.UploadSafetyPlanElement,
        "click": _vm.SetUploadValueToNull
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "upload-btn-wrapper"
    }, [(_vm.$hydrowareSecurityJS.canDownload_A('safetyplanmanagement')) ? _c('button', {
      staticClass: "btn-wrap safetyPlanDownloadButton",
      staticStyle: {
        "padding": "0px 2px 0px 2px",
        "font-size": "20px"
      },
      attrs: {
        "size": "small",
        "title": "Download",
        "name": 'speDownloadBtn_' + oneElement.idx,
        "id": 'speDownloadBtn_' + oneElement.idx,
        "disabled": oneElement.origFileName === '' || oneElement.origFileName == null
      },
      on: {
        "click": function($event) {
          return _vm.DownloadSafetyPlanElement(oneElement.addressOfElement)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('safetyplanmanagement')) ? _c('button', {
      staticClass: "btn-wrap safetyPlanDeleteButton",
      staticStyle: {
        "padding": "0px 4px 0px 4px",
        "font-size": "20px"
      },
      attrs: {
        "size": "small",
        "title": "Remove",
        "name": 'speDeleteBtn_' + oneElement.idx,
        "id": 'speDeleteBtn_' + oneElement.idx,
        "disabled": oneElement.origFileName === '' || oneElement.origFileName == null
      },
      on: {
        "click": _vm.UploadSafetyPlanElement
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      staticStyle: {
        "color": "white!important"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDisplay_A('safetyplanmanagement')) ? _c('span', [_vm._v("\n                    " + _vm._s(oneElement.elementName) + "\n                  ")]) : _vm._e()])])
  }), 0)], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2b954f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Compliance/safetyplan_management.vue
// module id = 802
// module chunks = 1